﻿export class booking_information_token {
    server: string | null = null;
    access_token: string | null = null;
    refresh_token: string | null = null
}